import type { HgsConfig } from '../../types/calculation-core.js';

export const DEFAULT_HGS_TOLL_CONFIG: HgsConfig = {
    "metadata": {
        "calculatorId": "hgs-toll",
        "version": "2026.10.28",
        "effectiveFrom": "2026-07-01",
        "lastVerifiedAt": "2026-10-28",
        "sources": [
            {
                "id": "kgm-tolls-2026",
                "title": "Güncel otoyol ve köprü ücretleri",
                "publisher": "Karayolları Genel Müdürlüğü",
                "url": "https://www.kgm.gov.tr/sayfalar/kgm/sitetr/otoyollar/ucretleryeni.aspx?v=1.0.22",
                "verifiedAt": "2026-10-28"
            },
            {
                "id": "avrasya-2026-07-01",
                "title": "1 Temmuz 2026 itibarıyla geçerli Avrasya Tüneli geçiş ücretleri",
                "publisher": "Avrasya Tüneli İşletme İnşaat ve Yatırım A.Ş.",
                "url": "https://www.avrasyatuneli.com/haberler-ve-duyurular/detay/1-temmuz-2026-itibariyla-gecerli-avrasya-tuneli-gecis-ucretleri-tarifesi",
                "verifiedAt": "2026-10-28"
            }
        ],
        "notes": [
            "Tutarlar KDV dahildir.",
            "Varsa otoyol giriş-çıkış mesafe ücreti bu sabit köprü/tünel ücretine dahil değildir."
        ]
    },
    "crossings": {
        "15-temmuz": {
            "name": "15 Temmuz Şehitler Köprüsü",
            "standardFees": [
                59,
                75,
                168,
                333,
                440,
                25
            ]
        },
        "fsm": {
            "name": "Fatih Sultan Mehmet Köprüsü",
            "standardFees": [
                59,
                75,
                168,
                333,
                440,
                25
            ]
        },
        "yss": {
            "name": "Yavuz Sultan Selim Köprüsü",
            "standardFees": [
                110,
                145,
                270,
                690,
                860,
                75
            ]
        },
        "osmangazi": {
            "name": "Osmangazi Köprüsü",
            "standardFees": [
                1170,
                1870,
                2225,
                2950,
                3720,
                820
            ]
        },
        "1915-canakkale": {
            "name": "1915 Çanakkale Köprüsü",
            "standardFees": [
                1170,
                1465,
                2635,
                2925,
                5560,
                295
            ]
        },
        "avrasya": {
            "name": "Avrasya Tüneli",
            "standardFees": [
                330,
                495,
                null,
                null,
                null,
                257.4
            ],
            "nightFees": [
                165,
                247.5,
                null,
                null,
                null,
                128.7
            ],
            "nightWindow": {
                "startInclusive": "00:00",
                "endExclusive": "05:00",
                "timeZone": "Europe/Istanbul"
            }
        }
    },
    "vehicleClassNames": [
        "1. sınıf (Otomobil)",
        "2. sınıf (Minibüs/Kamyonet)",
        "3. sınıf (Otobüs)",
        "4. sınıf (Kamyon/TIR)",
        "5. sınıf (Ağır vasıta)",
        "6. sınıf (Motosiklet)"
    ],
    "roundTripMultiplier": 2
};
